import React from "react";
import { Outlet, useLoaderData } from "react-router";

import { getBooksByID, getBooks, getFileCategory } from "API/swesum";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { BooksCard } from "./BooksCard";

export async function loader({ params }) {
  const books = await getBooksByID(params.booksID);
  const allBooks = await getBooks();
  const files = await getFileCategory("BOKFORING");
  return { books, allBooks, files };
}

export function BooksPage() {
  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} md={12}>
            <BooksCard />
            {/* <Outlet /> */}
          </Grid>
          <Grid item xs={12}>
            {/* <ClientInvoiceBundleWorkflows /> */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
